const storage = localStorage;

function localStorageSetItem(key, value, isAlreadyString = true) {

    try {
        if (isAlreadyString) {
            storage.setItem(key, value);
        } else {
            storage.setItem(key, JSON.stringify(value));
        }
    } catch (error) {
        return null;
    }

}

function localStorageGetItem(key, valueToBeReturnAsString = true) {

    try {
        const storedItem = storage.getItem(key);
        if (valueToBeReturnAsString) {
            return storedItem ? storedItem : null;
        } else {
            return storedItem ? JSON.parse(storedItem) : null;
        }
    } catch (error) {
        return null;
    }

}


function localStorageRemoveItem(key) {

    try {
        storage.removeItem(key);
    } catch (error) {
        return null;
    }

}


function localStorageClearAll() {

    try {
        storage.clear();
    } catch (error) {
        return null;
    }

}

export { localStorageSetItem, localStorageGetItem, localStorageRemoveItem, localStorageClearAll }
